'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  standard: '1GO0GpIl8_rnXrpoDF_srrWW4g62I7PlELQyEIY5Ww94',
  reduced: '16sR4MA4LwfTmc-hrN4NJoxZS-XMw0hNucoTdKeypAN0',
  minimum4Weeks: '1z91cy_yAE50Bxrm9XDNYUo4OmtvvtwF_YQx3eqDu1eo'
};